module.exports = __webpack_public_path__ + "static/yelan-b0d89bf9c5db988e58181d7ffdd70795.png";